// extracted by mini-css-extract-plugin
module.exports = {"messageText":"_7bcd0657 _a2211d17","wrapper":"_251c3c12","linkText":"_65bcb5bc _7bcd0657 _a2211d17","link":"_ad6f001"};